// Pantalla a la que se llega al iniciar sesion si no habia un destino pendiente.
export const DEFAULT_REDIRECT = '/controlPanel';

// El destino pendiente viaja en `?redirect=` y lo puede escribir cualquiera:
// solo se acepta una ruta interna del panel. Cualquier otra cosa (otro
// dominio, `//host`, `javascript:`) cae en la pantalla por defecto.
export const safeRedirect = (target) => {
    if (typeof target !== 'string') {
        return DEFAULT_REDIRECT;
    }
    const isPanelPath = target === DEFAULT_REDIRECT || target.startsWith(DEFAULT_REDIRECT + '/') || target.startsWith(DEFAULT_REDIRECT + '?');
    return isPanelPath && !target.includes('\\') ? target : DEFAULT_REDIRECT;
};
